module.exports = __webpack_public_path__ + "img/CRC2_NK.430f0975.png";